import styles from './Modals.module.css';

function ThresholdBar() {
    return (
        <>
            <div className={styles.thresholdBar}>
                <div className={`${styles.thresholdSegment} ${styles.thresholdLow}`}>No points</div>
                <div className={`${styles.thresholdSegment} ${styles.thresholdOk}`}>+100 pts (within ±15%)</div>
                <div className={`${styles.thresholdSegment} ${styles.thresholdHigh}`}>No points</div>
            </div>
            <div className={styles.thresholdLabel}>
                <span>Too low</span>
                <span>Accepted range</span>
                <span>Too high</span>
            </div>
        </>
    );
}

export default ThresholdBar;